module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-07-f39bfd1160bfd9d7665e66a73e08802f.jpg";